import { DataProcessing } from "./DataprocClass";
import { SCHEMA_ERROR_TYPE_PARAMS_KEY } from "../constants";
import {
  createUnitTestResponseObject,
  createErrorDetails,
  createCheckDuplicatesErrorMessage,
  createCheckExistsInErrorMessage,
} from "../HelperFunctions";
import * as Ajv from "ajv";

export class UnitTest {
  constructor(inputdata) {
    this.data = inputdata;
    this.DataprocHelpers = new DataProcessing(inputdata);
  }

  displayData() {
    return this.data;
  }

  checkSchema(schema) {
    // Initialize a new Ajv instance
    const jsonValidator = new Ajv({ allErrors: true, coerceTypes: true });
    const validate = jsonValidator.compile(schema);
    // Validate the data
    const dataToValidate =
      this.DataprocHelpers.addDisregagrdedPropertiesToInputData(this.data);
    const valid = validate(dataToValidate);
    const validationErrors = validate.errors;
    const schemaValidationErrors = [];
    valid === false &&
      validationErrors.forEach((validationError) => {
        const errorType = validationError.keyword;
        const errorParamsObjectKey =
          SCHEMA_ERROR_TYPE_PARAMS_KEY[errorType].key;
        const propertyNameIsAccessedFromInstancePath =
          SCHEMA_ERROR_TYPE_PARAMS_KEY[errorType]
            .propertyisAccesssedThroughInstancePath;
        const erroredProperty = propertyNameIsAccessedFromInstancePath
          ? validationError.instancePath.split("/")[2]
          : validationError.params[errorParamsObjectKey];
        const index = parseInt(validationError.instancePath.split("/")[1]);
        const isPropertyTheFailedItem =
          SCHEMA_ERROR_TYPE_PARAMS_KEY[errorType].isPropertyFailedItem;
        const failedItem = isPropertyTheFailedItem
          ? erroredProperty
          : dataToValidate[index][erroredProperty];
        schemaValidationErrors.push(
          createErrorDetails(
            failedItem,
            index,
            erroredProperty,
            validationError.message
          )
        );
      });
    return createUnitTestResponseObject(
      !(schemaValidationErrors.length > 0),
      schemaValidationErrors,
      null,
      "checkSchema"
    );
  }

  checkDuplicates(properties) {
    let combinedValues = [];
    const counts = {};
    const duplicates = [];

    // Dynamically generate combined values for each property
    properties.forEach((property) => {
      const values = this.DataprocHelpers.extractValuesByProperty(property);
      if (combinedValues.length === 0) {
        combinedValues = values.column_data.map((value) => `${value}`);
      } else {
        combinedValues = combinedValues.map(
          (combinedValue, index) =>
            `${combinedValue}-${values.column_data[index]}`
        );
      }
    });

    combinedValues.forEach((item, index) => {
      if (counts[item]) {
        if (counts[item] === 1) {
          duplicates.push(
            createErrorDetails(
              item,
              index,
              properties.join("-"),
              createCheckDuplicatesErrorMessage(properties.join("-"), item)
            )
          );
        }
        counts[item]++;
      } else {
        counts[item] = 1;
      }
    });

    return createUnitTestResponseObject(
      duplicates.length === 0,
      duplicates,
      properties.join("-"),
      "checkDuplicates"
    );
  }

  checkExistsIn(testArray, referenceArray, property, indexBool) {
    const missingValues = [];
    testArray.forEach((val, index) => {
      console.log(val, referenceArray);
      if (!referenceArray.includes(val)) {
        missingValues.push(
          createErrorDetails(
            val,
            index,
            property,
            createCheckExistsInErrorMessage(property, val, indexBool)
          )
        );
      }
    });
    return createUnitTestResponseObject(
      !(missingValues.length > 0),
      missingValues,
      property,
      "checkExistsIn"
    );
  }
}

/*
const getParent = (inputData, childElementParentName) =>{
  let returnedElement = null
  inputData.map(parentElement=>{
    if (childElementParentName===parentElement['nameString']) returnedElement = parentElement
  })
  return returnedElement
}

const checkForRecursion = (inputData, parentName, alreadySeenParents = [])=>{
    if (alreadySeenParents.includes(parentName)) return true
    alreadySeenParents.push(parentName)
    const parentElement = getParent(inputData, parentName)
    if (!parentElement['parentString']){
      return false
    }
    return checkForRecursion(inputData, parentElement['parentString'],alreadySeenParents)
}
*/
